import { State } from "@/models/storeModel";

export const state: State = {
  imgBlob: null,
  imgUrl: null,
};
